// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".access-token-details__list-item {\n  display: flex;\n  padding: 10px;\n  border-bottom: 1px solid #e3e3e3;\n\n  &:first-of-type {\n    border-top: 1px solid #e3e3e3;\n  }\n\n  & :first-child {\n    flex-basis: 100px;\n    min-width: 100px;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
